const DynamicParams = (props) => {
  const {
    initialSpace = true,
    label = 'PAR',
    index = 1,
    fieldNameToModify,
    values,
    action,
    disabled,
    identificator = '%%',
    customLabel = false
  } = props;

  let button = '';
  let space = initialSpace ? ' ' : '';
  if (action) {
    button = (
      <button
        disabled={disabled}
        className={`dynamicparams ${disabled ? 'disabled' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          action(fieldNameToModify, values[fieldNameToModify].concat(space + (customLabel ? customLabel + '=' : '') + identificator + (customLabel ? customLabel : label) + (customLabel ? '' : index) + identificator))
        }}
      ><i className="nexi-icon-plus"></i>{customLabel ? customLabel : label + index}
      </button>
    )
  }
  return (
    button
  );
};

export default DynamicParams;
